export default __webpack_public_path__ + "static/SRF Carasweet 5SG7804 - Fiche de spécifications et données techniques-b9031893a384053dcf9e7c0270725060.pdf";